'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const DxIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="DxIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Phone-Actions-Receive--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Phone Actions Receive Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M7.493 10.013a2 2 0 0 0 0 -2.829L5.371 5.063a2 2 0 0 0 -2.829 0L1.378 6.227A3 3 0 0 0 1 10a46.549 46.549 0 0 0 13 13 3 3 0 0 0 3.776 -0.379l1.164 -1.164a2 2 0 0 0 0 -2.828l-2.122 -2.121a2 2 0 0 0 -2.828 0l-0.707 0.707a47.481 47.481 0 0 1 -6.5 -6.5Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m13.499 10.501 10 -10"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m20.001 10.5 -6.5 0 0 -6.5"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

DxIcon.propTypes = {
  sx: PropTypes.object
}
